import React from 'react';
import PropTypes from 'prop-types';

const SizeSquare = ({ name, active, onClick }) => (
  <div
    onClick={onClick}
    className={`product-container__size ${active && 'product-container__size__active'}`}
  >
    {name}
  </div>
);

SizeSquare.propTypes = {
  name: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SizeSquare;



// WEBPACK FOOTER //
// ./src/components/ui/Product/SizeSquare/index.js